import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/leads", label: "线索库", end: false },
  { to: "/guide", label: "投稿指南", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden md:flex items-center justify-between bg-foreground-950 px-6 lg:px-10 py-2 text-xs text-background-100">
        <p className="flex items-center gap-2">
          <i className="ri-shield-check-line text-primary-400" aria-hidden="true" />
          <span>来源保护承诺：投稿人身份默认匿名，材料加密存储</span>
        </p>
        <p className="flex items-center gap-5">
          <span className="flex items-center gap-1.5">
            <i className="ri-phone-line text-accent-400" aria-hidden="true" />
            线索热线 400-826-3018
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-accent-400" aria-hidden="true" />
            每日 09:00 - 22:00
          </span>
        </p>
      </div>

      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-background-200"
            : "bg-background-50 border-transparent"
        }`}
      >
        <div className="mx-auto flex max-w-[1280px] items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
          <Link to="/" className="flex items-center gap-2.5" aria-label="蝌蚪爆料 首页">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-drop-line text-xl" aria-hidden="true" />
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-xl font-bold tracking-tight text-foreground-950">
                蝌蚪爆料
              </span>
              <span className="block text-[11px] tracking-[0.2em] text-foreground-500">
                KEDOU TIPS
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/guide#submit"
              className="hidden md:flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-2-line" aria-hidden="true" />
              我要投稿
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
            </button>
          </div>
        </div>

        {open && (
          <nav
            className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3"
            aria-label="移动端导航"
          >
            <ul className="flex flex-col">
              {navItems.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    className={({ isActive }) =>
                      `flex items-center justify-between rounded-md px-4 py-3 text-sm font-medium ${
                        isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700"
                      }`
                    }
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line text-lg" aria-hidden="true" />
                  </NavLink>
                </li>
              ))}
            </ul>
            <Link
              to="/guide#submit"
              className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50"
            >
              <i className="ri-send-plane-2-line" aria-hidden="true" />
              我要投稿
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}